var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletTheme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3497_34542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3844 6.98096H8.76901C7.19712 6.98096 5.92285 8.45433 5.92285 10.2718V30.017C5.92285 31.8345 7.19712 33.3079 8.76901 33.3079H34.3844C35.9563 33.3079 37.2305 31.8345 37.2305 30.017V10.2718C37.2305 8.45433 35.9563 6.98096 34.3844 6.98096Z",
    fill: "#9EA0FF",
    stroke: "#5A5CE7",
    strokeWidth: 3.077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9315,
    y: 14.0468,
    width: 12.1945,
    height: 10.0599,
    rx: 2.74783,
    fill: "white",
    stroke: "#5A5CE7",
    strokeWidth: 2.74783
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6054,
    cy: 19.0771,
    rx: 1.06731,
    ry: 1.06731,
    fill: "#5A5CE7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6933,
    cy: 10.7641,
    r: 6.90714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 2.6665C5.90768 2.6665 2.16602 6.40817 2.16602 10.9998C2.16602 15.5915 5.90768 19.3332 10.4993 19.3332C15.091 19.3332 18.8327 15.5915 18.8327 10.9998C18.8327 6.40817 15.091 2.6665 10.4993 2.6665ZM14.1243 13.9748C14.0077 14.1748 13.7993 14.2832 13.5827 14.2832C13.4743 14.2832 13.366 14.2582 13.266 14.1915L10.6827 12.6498C10.041 12.2665 9.56602 11.4248 9.56602 10.6832V7.2665C9.56602 6.92484 9.84935 6.6415 10.191 6.6415C10.5327 6.6415 10.816 6.92484 10.816 7.2665V10.6832C10.816 10.9832 11.066 11.4248 11.3243 11.5748L13.9077 13.1165C14.2077 13.2915 14.3077 13.6748 14.1243 13.9748Z",
    fill: "#5A5CE7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3497_34542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(4.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletTheme2);
export default __webpack_public_path__ + "static/media/WalletTheme2.d5ab947857b18697b95e2c843e045ffc.svg";
export { ForwardRef as ReactComponent };